<template>
  <section
    class="bg-black fixed z-50 top-0 bg-opacity-40 left-0 w-screen h-screen flex items-center justify-center"
  >
    <div class="bg-white p-8 rounded shadow-2xl w-96">
      <div class="flex justify-between items-center">
        <h2 class="font-bold text-2xl mb-4">Edit Dog Product</h2>
        <button @click="closeModal" class="font-bold text-2xl">x</button>
      </div>

      <el-form label-position="left" label-width="100px" :model="form">
        <el-form-item label="Name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="Price">
          <el-input type="number" v-model="form.price"></el-input>
        </el-form-item>

        <el-form-item label="Feature">
          <el-checkbox v-model="form.feature">Feature</el-checkbox>
        </el-form-item>

        <el-form-item label="Description">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>

        <upload-image
          :description="'Cropped at 1x1.'"
          cropOptions="1:1"
          label="Image"
          required="true"
          v-model="form.image"
          class="mr-2"
        />

        <button @click="update()" class="btn mt-4">save</button>
      </el-form>
    </div>
  </section>
</template>
<script>
import UploadImage from "@/components/UploadImage.vue";
import { db } from "@/db";
export default {
  props: {
    value: Object,
  },
  components: {
    UploadImage,
  },
  data: function () {
    return {
      form: Object,
    };
  },
  mounted() {
    this.form = this.value;
  },
  firestore: {
    products: db.collection("products"),
  },
  methods: {
    closeModal() {
      this.$emit("exit", true);
    },
    update() {
      // if exists
      if (this.form.id) {
        this.$firestoreRefs.products
          .doc(this.form.id)
          .update(this.form)
          .then(() => {
            console.log("product updated!");
          });
      } else {
        // if does not exists, create it
        db.collection("products").add(this.form);
      }
      this.closeModal();
    },
  },
};
</script>